import React from 'react'
import { cn } from '@/lib/utils'

interface LogomarkProps {
  className?: string
  /**
   * 'dark' uses the navy logomark (for light backgrounds)
   * 'light' uses the white logomark (for dark backgrounds)
   */
  variant?: 'dark' | 'light'
  size?: number
}

/**
 * The Mphasis logomark.
 * Use `variant="dark"` on light backgrounds, `variant="light"` on dark backgrounds.
 */
export function Logomark({
  className,
  variant = 'dark',
  size = 40,
}: LogomarkProps) {
  const src =
    variant === 'light'
      ? '/mphasis-light.jpg'
      : '/mphasis-dark.jpg'

  return (
    <div 
      className={cn('relative shrink-0 flex items-center justify-center p-2', className)}
      style={{ width: size, height: size }}
    >
      <img
        src={src}
        alt='Mphasis'
        className='w-full h-full object-contain rounded'
        style={{ maxWidth: '100%', maxHeight: '100%' }}
      />
    </div>
  )
}

